module.exports = __webpack_public_path__ + "static/img/8.caf65a1b.jpg";